import { render } from "./index.vue?vue&type=template&id=71d728b1&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=71d728b1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Code\\vue\\xypt-admin-wx\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d728b1"]])

export default __exports__